module.exports = __webpack_public_path__ + "images/LoginPageVector.69262549.svg";